var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubixWires9Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 813,
    height: 708,
    viewBox: "0 0 813 708",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 141.58V226.12L236.88 461.39V381.21L85.27 231.6L236.88 257.15V177.04L2.5 141.58Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 141.58L236.88 177.04L269.51 158.16L258.89 117.04L89.4 91.44L2.5 141.58Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2695 231.6L236.88 381.21L315.4 335.91L310.86 318.33L244.43 252.78L236.88 257.15L85.2695 231.6Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.881 381.21V461.39L323.781 411.24V368.29L315.401 335.91L236.881 381.21Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.881 177.04V257.15L287.501 227.95L269.511 158.16L236.881 177.04Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.131 52.14L323.781 368.29V368.41L399.001 659.78L479.351 706.21L322.481 98.51L242.131 52.14Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M242.131 52.14L322.481 98.51L409.321 48.37L328.971 2L242.131 52.14Z",
    fill: "#459AA4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M244.43 252.78L310.86 318.33L287.5 227.95L244.43 252.78Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M322.48 98.51L479.35 706.21L566.19 656.07L556.16 617.19L489.32 607.1V526.99L527.25 505.1L504.77 418.14L489.32 402.92V358.26L409.32 48.37L322.48 98.51Z",
    fill: "#FBB93E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M489.32 526.99V607.1L723.7 642.5V557.96L489.32 322.75V402.92L640.99 552.47L489.32 526.99Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M489.32 322.75L723.7 557.96V642.5L810.54 592.35V507.81L576.22 272.61L489.32 322.75Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M489.32 526.99L640.99 552.47L568.66 481.15L489.32 526.99Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M504.77 418.14L527.25 505.1L568.66 481.15L504.77 418.14Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M527.25 505.1L504.77 418.14",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M489.32 358.26V402.92L640.99 552.47L489.32 526.99V607.1L723.7 642.5V557.96L489.32 322.75V358.26Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M323.781 368.41L399.001 659.78L479.351 706.21L322.481 98.51L242.131 52.14L323.781 368.29V368.41Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 141.58V226.12L236.88 461.39V381.21L85.27 231.6L236.88 257.15V177.04L2.5 141.58Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M258.89 117.04L89.4 91.44L2.5 141.58",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M236.881 177.04L269.511 158.16",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M236.881 257.15L287.501 227.95",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M244.43 252.78L310.86 318.33",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M236.881 381.21L315.401 335.91",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M236.881 461.39L323.781 411.24V368.29",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M242.131 52.14L328.971 2L409.321 48.37L489.321 358.26",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M409.32 48.37L322.48 98.51",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M556.16 617.19L566.19 656.07L479.35 706.21",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M489.32 322.75L576.22 272.61L810.54 507.81V592.35L723.7 642.5",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M489.32 526.99L568.66 481.15",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubixWires9Dark);
export default __webpack_public_path__ + "static/media/RubixWires9Dark.282896b3c4d132b5568fbf189d1241b1.svg";
export { ForwardRef as ReactComponent };